module.exports = __webpack_public_path__ + "img/concept-ai-engineering.7dd12c42.svg";